import React from 'react';
import {
  CompactTable,
  defaultFrontendSort,
  MonitorProfile,
  Page,
  PageContent,
  PermissionGuard,
  useAssetTranslation,
} from '@mss/mss-component-library';
import Button from '../../Button';
import { sanitizedUrl } from '../../../asset/util/sanitize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useMonitorProfilesQuery } from '../../../asset/services/queries';
import Breadcrumbs from '../../Breadcrumbs';

export default function List() {
  const { t } = useAssetTranslation();
  const history = useHistory();
  const { url } = useRouteMatch();
  const query = useMonitorProfilesQuery();

  function onRowClick(record: MonitorProfile) {
    return function () {
      history.push(`${sanitizedUrl(url)}/${record.id}`);
    };
  }

  function onAddClick() {
    history.push(`${sanitizedUrl(url)}/add`);
  }

  return (
    <Page
      breadCrumbs={<Breadcrumbs />}
      main={
        <PageContent
          title={t('Manage monitor profiles')}
          actions={
            <PermissionGuard codename={'change_automationmonitorprofile'}>
              <Button onClick={onAddClick} data-ta="newMonitorProfileButton">
                <FontAwesomeIcon icon={faPlus} className="mr-1" />
                {t('ADD MONITOR PROFILE')}
              </Button>
            </PermissionGuard>
          }
        >
          <CompactTable
            dataSource={query.data}
            loading={query.isLoading}
            onRow={(record: MonitorProfile) => ({
              onClick: onRowClick(record),
            })}
            columns={[
              {
                key: 'name',
                title: t('Name'),
                dataIndex: 'name',
                sorter: defaultFrontendSort('name'),
              },
              {
                key: 'asset_type',
                title: t('Asset/Application sub type'),
                dataIndex: 'asset_type',
                render: (assetType: string) =>
                  t(assetType.split('.')[1] ?? '-'),
                width: 250,
                sorter: (a: MonitorProfile, b: MonitorProfile) => {
                  const [_, aSubType = '-'] = a.asset_type.split('.');
                  const [__, bSubType = '-'] = b.asset_type.split('.');
                  // If the subType is '-' then it should be at the end, otherwise it should just use the localeCompare
                  return aSubType === '-'
                    ? 1
                    : bSubType === '-'
                      ? -1
                      : aSubType.localeCompare(bSubType);
                },
              },
              {
                key: 'monitors',
                title: t('Enabled monitors'),
                dataIndex: 'monitors',
                render: (monitors: any[]) =>
                  monitors.filter(x => x.enabled).length,
                width: 150,
                sorter: (a: MonitorProfile, b: MonitorProfile) =>
                  a.monitors.length - b.monitors.length,
              },
            ]}
          />
        </PageContent>
      }
    />
  );
}
